<app-global-info
  icon="mdi-alert-circle-outline"
  [title]="'navigation-error.title' | translate"
  [description]="'navigation-error.text' | translate"
  [showButton]="true"
  [buttonText]="'navigation-error.actions.try-again' | translate"
  (clicked)="back()"
></app-global-info>
